"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistOrLogin = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var guMember_1 = require("../../model/guMember");
var service_1 = require("../../../library/base/service");
var RegistOrLogin = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(RegistOrLogin, _super);
    function RegistOrLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '注册登录接口';
        _this.code = '300402';
        _this.desc = '注册登录接口';
        _this.requestParams = new guMember_1.RegistOrLoginRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return RegistOrLogin;
}(service_1.BaseService));
exports.RegistOrLogin = RegistOrLogin;
//# sourceMappingURL=registOrLogin.js.map